import "../../style.css";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ChatContainer from "./components/ChatContainer/ChatContainer";
import Canvas from "../../components/Canvas/Canvas";
import Splitter from "../../components/Splitter/Splitter";
import NavigationButtons from "../../components/Buttons/NavigationButtons";
import ExportButton from "../../components/Buttons/ExportButton";
import ImportButton from "../../components/Buttons/ImportButton";
import DirectRenderButton from "../../components/Buttons/DirectRenderButton";
import CheckersButton from "../../components/Buttons/CheckersButton";
import SettingsButton from "../../components/Buttons/SettingsButton";
import ResetButton from "../../components/Buttons/ResetButton";
//import CheckersButton from '../../components/Buttons/CheckersButton';
import LogoutButton from "../../components/Buttons/LogoutButton";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaEllipsisH } from "react-icons/fa";
import { useDispatch } from "react-redux";

import initialSettings from '../../constants/settings.json';
import { storageKeys } from "../../constants/storageKeys";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";

const HomePage = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  

  useEffect(() => {
    const sessionKey = Cookies.get("sessionKey");
    const sessionID = sessionKey ? sessionKey : uuidv4();
    localStorage.setItem(storageKeys.SESSION_ID, sessionID);


    if (!localStorage.getItem(storageKeys.LLM_API_URL) || !localStorage.getItem(storageKeys.LLM_MODEL)) {
      navigate("/enterapikey");
    }

    Object.entries(initialSettings.localStorage).forEach(([key, value]) => {
      if (
        localStorage.getItem(key) === null &&
        key !== storageKeys.LLM_API_URL &&
        key !== storageKeys.LLM_MODEL
      ) {
        localStorage.setItem(key, value);
      }
    });

  }, [dispatch, navigate]);

  return (
    <Splitter>
      <ChatContainer />
      <Canvas>
        <ResetButton />
        <NavigationButtons />
        <CheckersButton />
        <DirectRenderButton />
        <SettingsButton />

        <Dropdown>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>More Actions</Tooltip>}
          >
            <Dropdown.Toggle
              variant="light"
              className="bg-gray rounded-circle btn-centered-icon"
              bsPrefix="btn"
            >
              <FaEllipsisH className="icon-dark" />
            </Dropdown.Toggle>
          </OverlayTrigger>

          <Dropdown.Menu>
            <ExportButton variant="dropdown" />
            <ImportButton />
            <LogoutButton />
          </Dropdown.Menu>
        </Dropdown>
      </Canvas>
    </Splitter>
  );
};

export default HomePage;
